<template>
  <bottom-drawer
    v-model:visible="isShowContent"
    :action-label="$t('all_clear')"
    :is-submittable="isSubmittable"
    :show-action="props.showClear"
    :show-footer="true"
    :submit-label="$t('filter_result_and_action_button', { result: props.productCount })"
    :title="props.title"
    :trigger-active="props.triggerActive"
    :trigger-icon="props.triggerIcon"
    :trigger-label="props.triggerLabel"
    :is-loading="props.isLoading"
    @action="handleFilterClear"
    @close="handleClose"
    @submit="handleSubmit"
  >
    <slot :visible="isShowContent" :onValidation="handleContentValidation">popup content</slot>
  </bottom-drawer>
</template>

<script setup lang="ts">
import BottomDrawer from '@/components/common/bottom-drawer.vue'

const props = withDefaults(
  defineProps<{
    title: string
    productCount: number
    triggerLabel: string
    triggerIcon: string
    triggerActive: boolean
    showClear: boolean
    isLoading: boolean
  }>(),
  {
    title: '',
    productCount: 0,
    triggerLabel: '',
    triggerIcon: '',
    triggerActive: false,
    showClear: false,
    isLoading: false,
  }
)

const emit = defineEmits<{
  (event: 'clear'): void
  (event: 'submit'): void
  (event: 'close'): void
}>()

const isShowContent = ref(false)
const isContentValid = ref(true)
const isSubmittable = computed(() => isContentValid.value)

const handleFilterClear = () => emit('clear')

const handleSubmit = () => {
  isShowContent.value = false
  emit('submit')
}

const handleClose = () => {
  emit('close')
}

const handleContentValidation = (result: boolean) => {
  isContentValid.value = result
}
</script>

<style lang="scss">
.n-drawer.n-drawer--bottom-placement {
  @apply rounded-t-12px;
  .n-drawer-content-wrapper {
    max-height: calc(100dvh - 64px);
  }
  .n-drawer-header {
    @apply sticky top-0 bg-white z-10;
    .n-drawer-header__main {
      @apply w-full;
    }
  }
  .n-drawer-body {
    @apply flex-1 pb-6;
  }
  .n-drawer-footer {
    @apply sticky bottom-0 bg-white;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  }
}
</style>
